
import { defineComponent } from 'vue';
import { menuItems } from '@/constant/menuItems'
import { mapGetters } from 'vuex'
import MobileMenu from '@/components/MobileMenu.vue'

export default defineComponent({
  name: 'NavBar',
  components: {
    MobileMenu
  },
  computed: {
    ...mapGetters({
      isMobile: 'global/getIsMobile'
    }),
    isOnlyOne () {
      return this.$route.name === 'CreateReview'
    },
    checkRouteHome () {
      if (this.$route.path === '/') {
        return 'active-route'; // Adds 'home-class' when the route is '/home'
      }
      else{
        return "";
      }
    },
    checkRestRoutes () {
      if (this.$route.path === '/zostan-super-wykonawca' || this.$route.path === '/aplikacja' || this.$route.path === '/program-lojalnosciowy' || this.$route.path === '/youtube') {
        return 'active-route'; // Adds 'home-class' when the route is '/home'
      }
      else{
        return "";
      }
    },
  },
  methods: {
    toggleMenuVisibility() {
      this.menuVisible = !this.menuVisible; // Toggle the boolean value
    },
    /* eslint-disable */
    hideMenuVisibilityFromOutside(event: MouseEvent) {
      if (!event.target || !(event.target as HTMLElement).closest('.nav-item')) {
        this.menuVisible = false;
      }
    },
    hideMenuVisibility() {
        this.menuVisible = false;
    },
    redirectToSuperWykonawca() {
      this.$router.push({ name: 'SuperWykonawca' }); // Redirects using the route name
      this.hideMenuVisibility();
    },
    redirectToHome() {
      this.$router.push({ name: 'Home' }); // Redirects using the route name
      this.hideMenuVisibility();
    },
    redirectToAplikacja(){
      this.$router.push({ name: 'Aplikacja' }); // Redirects using the route name
      this.hideMenuVisibility();
    },
    redirectToProgram(){
      this.$router.push({ name: 'ProgramLojanosciowy' }); // Redirects using the route name
      this.hideMenuVisibility();
    },
    redirectToYoutube(){
      this.$router.push({ name: 'Youtube' }); // Redirects using the route name
      this.hideMenuVisibility();
    }
  },
  data () {
    return {
      menuItems,
      menuVisible:false,
    }
  },
  mounted() {
    // Add a click event listener to the body when the component is mounted
    document.body.addEventListener('click', this.hideMenuVisibilityFromOutside);
  },
  beforeUnmount() {
    // Remove the click event listener from the body when the component is destroyed
    document.body.removeEventListener('click', this.hideMenuVisibilityFromOutside);
  },
});
